var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    transform: "rotate(90)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.65 24q-.975 0-1.763-.337-.787-.338-1.412-.963l-7.65-7.825 1.375-1.3q.35-.325.85-.337.5-.013.875.212l3.9 2.225V4q0-.625.45-1.075.45-.45 1.075-.45.6 0 1.05.45.45.45.45 1.075v7.1h1V1.525q0-.625.45-1.075.45-.45 1.075-.45t1.075.45q.45.45.45 1.075V11.1h1V2.5q0-.625.45-1.075.45-.45 1.075-.45t1.075.45q.45.45.45 1.075v8.6h1V5.45q0-.625.45-1.075.45-.45 1.075-.45t1.075.45q.45.45.45 1.075v14.375q0 1.75-1.212 2.963Q20.575 24 18.825 24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.5775cdb718be23bb22cda81deee03286.svg";
export { ForwardRef as ReactComponent };